import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2, Link } from '@zola/zola-ui';

import './ChecklistDeleteTaskModal.less';

const ChecklistDeleteTaskModal = ({ onDelete, onCancel, taskTitle }) => (
  <div className="checklist__deleteTask--container">
    <h2>Are you sure you want to delete this task from your checklist?</h2>

    <div className="checklist__deleteTask--task">
      <span className="checklist__deleteTask--taskTitle">{taskTitle}</span>
    </div>

    <p className="checklist__deleteTask--warningCopy">
      This{' '}
      <strong>
        <u>cannot</u>
      </strong>{' '}
      be undone.
    </p>
    <div className="checklist__deleteTask--footer">
      <ButtonV2 variant="tertiary" onClick={onDelete}>
        Delete
      </ButtonV2>
      <div className="checklist__deleteTask--cancel">
        <Link onClick={onCancel}>Cancel</Link>
      </div>
    </div>
  </div>
);

ChecklistDeleteTaskModal.propTypes = {
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  taskTitle: PropTypes.string,
};

ChecklistDeleteTaskModal.defaultProps = {};

export default ChecklistDeleteTaskModal;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDeleteTaskModal/ChecklistDeleteTaskModal.jsx